import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Heart } from "lucide-react";
import { toast } from "sonner";

const HERO_IMG = "https://images.unsplash.com/photo-1778640331184-dc4c3e2608e1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBhaXJibmIlMjBpbnRlcmlvciUyMGxpdmluZyUyMHJvb218ZW58MHx8fHwxNzg1MjczMDI1fDA&ixlib=rb-4.1.0&q=85";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) { toast.success("Welcome back!"); nav("/dashboard"); }
    else toast.error(res.error);
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-white">
      <div className="hidden lg:block relative">
        <img src={HERO_IMG} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/50" />
        <div className="relative z-10 h-full flex flex-col justify-between p-12 text-white">
          <Link to="/" className="flex items-center gap-2">
            <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-white/10 backdrop-blur">
              <Heart className="w-4 h-4 text-brand-pink" fill="#E91E63" />
            </span>
            <div className="font-display text-2xl">Host <span className="font-script text-brand-pink">Hustle</span></div>
          </Link>
          <div>
            <div className="font-script text-3xl text-brand-pink mb-3">Welcome back</div>
            <div className="font-display text-4xl leading-tight">Smarter hosting.<br/>Higher returns.</div>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center p-6 lg:p-12">
        <form onSubmit={submit} className="w-full max-w-md" data-testid="login-form">
          <div className="uppercase tracking-[0.28em] text-xs text-brand-pink mb-3">Log In</div>
          <h1 className="font-display text-4xl mb-8">Continue your hustle.</h1>
          <div className="space-y-5">
            <div>
              <Label className="mb-2 block">Email</Label>
              <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="rounded-full h-12 px-5 border-neutral-200" />
            </div>
            <div>
              <Label className="mb-2 block">Password</Label>
              <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="rounded-full h-12 px-5 border-neutral-200" />
            </div>
          </div>
          <Button disabled={loading} type="submit" size="lg" data-testid="login-submit" className="w-full mt-8 rounded-full bg-brand-pink hover:bg-brand-pink/90 text-white btn-pink-glow">
            {loading ? "Signing in…" : "Sign in"}
          </Button>
          <p className="text-sm text-neutral-500 mt-6 text-center">
            New here? <Link to="/register" className="text-brand-pink font-medium">Create an account</Link>
          </p>
          <p className="text-xs text-neutral-400 mt-3 text-center">Try the demo: student@hosthustle.com / Student2026!</p>
        </form>
      </div>
    </div>
  );
}
